import React from 'react';
import WhiteButtonEditBloc from './Buttons/WhiteButtonEditBloc';
import { Popup } from 'semantic-ui-react';

const styles = {
	containerField: {
		display: 'flex',
	},
	textField: {
		paddingLeft: 10,
		fontSize: '0.8em',
	},
};
const ContainerField = ({
	label,
	icon,
	field,
	style,
	textFieldStyle,
	onClick = null,
	buttonText = 'Action',
	popupContent,
	useButton = true,
}) => {
	field = field === true ? 'Oui' : field === false ? 'Non' : field;

	const body = () => (
		<div
			style={{ ...styles.containerField, ...style }}
			onClick={() => {
				if (!useButton) onClick();
			}}
		>
			{icon !== undefined && icon}
			<span style={{ ...styles.textField, ...textFieldStyle }}>
				{label} {field !== null ? field : ' - '}
				{onClick && useButton && (
					<WhiteButtonEditBloc
						style={{ marginLeft: 5 }}
						text={buttonText}
						onClick={(e) => {
							if (e !== undefined) e.preventDefault();
							onClick();
						}}
					/>
				)}
			</span>
		</div>
	);

	return (
		<>
			{popupContent && <Popup trigger={body()} content={popupContent} basic />}
			{!popupContent && body()}
		</>
	);
};

export default ContainerField;
